<template>
  <div class="batch-upload">
    <div class="global_popup_header">
      {{ $t("content.books.batchUpload")
      }}<i @click="$store.commit('windowHandle')"></i>
    </div>
    <div class="global_popup_body">
      <div class="upload-tips" v-if="!files.length">
        {{ $t("content.books.batchUploadTips") }}
      </div>
      <div v-else class="upload-container">
        <div class="upload-list" v-bar>
          <div>
            <div
              class="upload-item"
              v-for="(file, index) in files"
              :key="file.id"
            >
              <p>{{ index + 1 }}.</p>
              <!-- <p>
                                <img v-if="file.thumb" :src="file.thumb" width="40" height="auto" />
                                <span v-else>No Image</span>
                            </p> -->
              <div class="upload-item-name">
                <p class="omitText">{{ file.name }}</p>
              </div>
              <div class="upload-item-progress">
                <el-progress
                  type="line"
                  :percentage="Number(file.progress.split('.')[0])"
                  :status="statusBack(file)"
                ></el-progress>
              </div>
              <p class="upload-item-size">{{ file.size | renderSize }}</p>
              <p class="upload-item-status">
                <span v-if="file.error">{{ $t("commonMsg.failure") }}</span>
                <span v-else-if="file.success">{{
                  $t("commonMsg.success")
                }}</span>
                <span v-else-if="file.active">{{
                  $t("commonMsg.uploading")
                }}</span>
                <span v-else>{{ $t("commonMsg.pending") }}</span>
              </p>
              <el-dropdown trigger="click">
                <button class="global-button-style" style="marginLeft:0;">
                  {{ $t("commonMsg.handle")
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="delFile(file)">{{
                    $t("commonMsg.del")
                  }}</el-dropdown-item>
                  <el-dropdown-item @click.native="uploadFile(file)">{{
                    $t("commonMsg.upload")
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <file-upload
        ref="upload"
        v-model="files"
        post-action="/api/1/books/upload"
        :data="data"
        :drop="true"
        multiple
        :headers="{ 'Accept-language': language, 'Authorization': `Bearer ${this.$cookie.get('token')}` }"
        :thread="5"
        @input-file="inputFile"
        @input-filter="inputFilter"
        extensions="txt, apk, epub, pdf, xlsx, xls, doc, docx, ppt, pptx"
        accept=".txt, .apk, .epub, .pdf, .xlsx, xls, .doc, .docx, .ppt, .pptx"
      >
      </file-upload>
    </div>
    <div class="batchBtnHandle">
      <button
        class="global-button-style"
        @click="$refs.upload.$el.querySelector('input').click()"
      >
        {{ $t("content.books.addFile") }}
        <!-- <label style="cursor: pointer;fontWeight:normal;" for="file">添加文件</label> -->
      </button>
      <button class="global-button-style" @click="uploadAllFile">
        {{ $t("content.books.startUpload") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    cateId: String
  },
  computed: {
    ...mapGetters(["language"])
  },
  data() {
    return {
      files: [],
      data: {
        cateId: this.$route.query.id
      }
    };
  },
  methods: {
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        // update

        if (newFile.progress !== oldFile.progress) {
          // 进度回调
        }
        if (newFile.error && !oldFile.error) {
          this.elMsg(newFile.response.message, "error");
          // 失败回调
        }
        if (newFile.success && !oldFile.success) {
          // 成功回调
          this.$emit("onSuccess", newFile.response);
          if (this.$refs.upload.uploaded) {
            this.$store.commit("windowHandle");
          }
        }
      }
      if (!newFile && oldFile) {
        // 删除回调
        if (oldFile.success && oldFile.response.id) {
          // 上传成功的在这调用删除接口
        }
      }
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // 添加文件

        // 过滤非法文件
        // 不会添加到 files 去
        newFile.name.split("/")[1]
          ? (newFile.name = newFile.name.split("/")[1])
          : "";

        if (
          !/\.(txt|apl|epub|pdf|xlsx|xls|doc|docx|ppt|pptx)$/i.test(
            newFile.name
          )
        ) {
          !/\.(DS_Store)$/i.test(newFile.name)
            ? this.elMsg(
                "只能上传txt, apk, epub, pdf, xlsx, xls, doc, docx, ppt, pptx格式",
                "error"
              )
            : "";
          return prevent();
        }
      }
      // if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      //     // 创建 blob 字段
      //     newFile.blob = ''
      //     let URL = window.URL || window.webkitURL
      //     if (URL && URL.createObjectURL) {
      //     newFile.blob = URL.createObjectURL(newFile.file)
      //     }
      //     // 缩略图
      //     newFile.thumb = ''
      //     if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
      //     newFile.thumb = newFile.blob
      //     }
      // }
    },

    delFile(file) {
      this.$refs.upload.remove(file);
    },

    uploadAllFile() {
      this.$refs.upload.active = true;
    },

    uploadFile(file) {
      this.$refs.upload.update(file, { active: true });
    },

    statusBack(file) {
      if (file.error) {
        return "exception";
      } else if (file.success) {
        return "success";
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.batch-upload {
  @include globalPopup(600px, 400px);
  .upload-tips {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 4px;
    border: 1px dashed $globalBGColor;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .upload-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 4px;
    border: 1px dashed $globalBGColor;
    .upload-list {
      width: 100%;
      height: 100%;
      .upload-item {
        padding: 10px;
        border-bottom: 1px dashed $globalBGColor;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .upload-item-name {
          width: 150px;
          min-width: 150px;
        }
        .upload-item-progress {
          width: 150px;
        }
      }
    }
  }
  .global_popup_body {
    padding: 0 20px 20px;
  }
  .batchBtnHandle {
    text-align: right;
    padding: 0 20px 20px;
  }
}
</style>
